export const DIVISIBLE_TICK_AMOUNT = 70;